/* eslint-disable max-len */
import React, { Component } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Formik, Form, Field } from 'formik';
import { Button } from 'primereact/button';
import * as qs from 'query-string';
import * as Yup from 'yup';
import gql from 'graphql-tag';
import {
  intlShape,
  growlShape,
  locationShape,
  historyShape,
} from '../components/prop-types';
import { withGrowl } from '../components/GrowlNotifications';
import { LegacyInputPasswordComponent } from '../components/prime-formik';
import apollo from '../services/apollo';

const RESET_PASSWORD = gql`
  mutation($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;

const resetOwnPassword = input => apollo
  .mutate({
    mutation: RESET_PASSWORD,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const i18n = defineMessages({
  passwordRequired: {
    id: 'login.password_required',
    defaultMessage: 'Password is required',
  },
  passwordTooShort: {
    id: 'password_validation.minimum_length',
    defaultMessage: 'Password must be at least 12 characters long',
  },
  passwordTooLong: {
    id: 'password_validation.maximum_length',
    defaultMessage: 'Invalid password',
  },
  passwordConfirmationRequired: {
    id: 'login.password_confirmation_required',
    defaultMessage: 'Password confirmation is required',
  },
  passwordConfirmationDoesNotMatch: {
    id: 'login.password_confirmation_does_not_match',
    defaultMessage: 'Password confirmation does not match',
  },
});

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.resetPassword = this.resetPassword.bind(this);
  }

  async resetPassword(values, resetForm) {
    const {
      growl,
      history,
    } = this.props;

    const {
      password,
      userId,
      token,
    } = values;

    try {
      await resetOwnPassword({
        password,
        userId,
        token,
      }).then(() => {
        history.push('/');
      });
    } catch (error) {
      growl.show({ severity: 'error', detail: error.message, sticky: true });
      resetForm();
    }
  }


  render() {
    const {
      location,
      intl: { formatMessage },
    } = this.props;

    const { userId, token } = qs.parse(location.search);

    const initialValues = {
      password: '',
      confirmPassword: '',
      userId,
      token,
    };

    const validationSchema = Yup.object().shape({
      password: Yup.string()
        .min(12, formatMessage(i18n.passwordTooShort))
        .max(100, formatMessage(i18n.passwordTooLong))
        .required(formatMessage(i18n.passwordRequired)),
      confirmPassword: Yup.string().when('password', {
        is: val => (!!(val && val.length > 0)),
        then: Yup.string().oneOf(
          [Yup.ref('password')],
          formatMessage(i18n.passwordConfirmationDoesNotMatch),
        ),
      }).required(formatMessage(i18n.passwordConfirmationRequired)),
    });

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => {
          const { resetForm } = formikBag;
          this.resetPassword(values, resetForm);
        }}
        render={props => (
          <Form onSubmit={props.handleSubmit}>
            <input type="hidden" name="token" value={token} />
            <input type="hidden" name="userId" value={userId} />
            <div className="p-grid p-fluid p-justify-center logo-top">
              <img src="images/default-195.png" className="brand center-block" alt="GPI Logo" />
            </div>
            <div className="p-grid p-fluid p-justify-center">
              <div className="p-col-6 p-md-3">
                <FormattedMessage id="reset_password.instructions" defaultMessage="Choose a new password">
                  {text => (
                    <h4 className="center-aligned-instructions">{text}</h4>
                  )}
                </FormattedMessage>
              </div>
            </div>
            <div className="p-grid p-fluid p-justify-center">
              <div className="p-col-6 p-md-3">
                <FormattedMessage id="register.password" defaultMessage="Password">
                  {text => <Field id="password" name="password" component={LegacyInputPasswordComponent} placeholder={text} />}
                </FormattedMessage>
              </div>
            </div>
            <br />
            <div className="p-grid p-fluid p-justify-center">
              <div className="p-col-6 p-md-3">
                <FormattedMessage id="register.confirm_password" defaultMessage="Confirm password">
                  {text => <Field id="confirmPassword" name="confirmPassword" component={LegacyInputPasswordComponent} placeholder={text} />}
                </FormattedMessage>
              </div>
            </div>
            <br />
            <div className="p-grid p-fluid p-justify-center">
              <div className="p-col-6 p-md-1">
                <FormattedMessage id="actions.submit" defaultMessage="Submit">
                  {text => (
                    <Button
                      type="submit"
                      label={text}
                      disabled={props.isSubmitting}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          </Form>
        )}
      />
    );
  }
}

ResetPassword.propTypes = {
  intl: intlShape.isRequired,
  growl: growlShape.isRequired,
  location: locationShape.isRequired,
  history: historyShape.isRequired,
};

export default injectIntl(withGrowl(ResetPassword));
